// This import loads the firebase namespace along with all its type information.
import CustomerAdministrator from './customer-administrator-model'

export async function load_customerAdministrators(): Promise<
  CustomerAdministrator[]
> {
  throw 'Not implemented'
}

export async function delete_customerAdministrator(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_customerAdministrator(): Promise<CustomerAdministrator> {
  throw 'Not implemented'
}
